import { h, Component } from 'preact';
import style from './style'
import {TimeSlot, I18n} from 'components/elements'

export default (props)=>{
	return (
        <div class={style.select}>
            {props.timeSlots.length ?
                props.timeSlots.map((timeSlot) => {
                    return (
                        <TimeSlot 
                            {...timeSlot}
                            onSelect={props.onSelect}
                            selected={props.selectedTimeSlot.id == timeSlot.id}
                        />
                    )
                })
            :
                <div class={style.noAppointments}><I18n>noAppointments</I18n></div>
            }
        </div>
	)
}


// WEBPACK FOOTER //
// ./components/groups/TimeSlotColumn/index.js